/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div data-id="genaric-page" v-append-html="pageContent"/>
</template>

<script>

export default {
  head () {
    const title = this.$store.state.cms.meta.title
    const description = this.$store.state.cms.meta.description
    const keywords = this.$store.state.cms.meta.keywords
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: description
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: keywords
      }]
    }
  },
  computed: {
    pageContent () {
      return this.$store.getters['cms/getContentPage']
    }
  },
  async asyncData (ctx) {
    return ctx.store.dispatch('cms/getPage', ctx.route.params.slug)
      .catch(() => {
        ctx.redirect({ name: 'page-not-found', params: { lang: ctx.store.state.ui.storeViewCode } })
      })
  }
}
</script>
